"use client";
/*
 * Documentation:
 * TicketStatus — https://app.subframe.com/ae91faa555e6/library?component=TicketStatus_2da1965c-4de7-4ca4-96c3-7dcbde391f67
 */

import React from "react";
import * as SubframeUtils from "../utils";
import * as SubframeCore from "@subframe/core";

interface TicketStatusRootProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: SubframeCore.IconName;
  text?: React.ReactNode;
  variant?: "default" | "overdue" | "reminder";
  className?: string;
}

const TicketStatusRoot = React.forwardRef<HTMLElement, TicketStatusRootProps>(
  function TicketStatusRoot(
    {
      icon = "FeatherCalendar",
      text,
      variant = "default",
      className,
      ...otherProps
    }: TicketStatusRootProps,
    ref
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          "group/2da1965c flex w-14 flex-col items-center",
          className
        )}
        ref={ref as any}
        {...otherProps}
      >
        <SubframeCore.Icon
          className={SubframeUtils.twClassNames(
            "text-body font-body text-subtext-color",
            {
              hidden: variant === "reminder",
              "text-error-700": variant === "overdue",
            }
          )}
          name="FeatherAlertTriangle"
        />
        <SubframeCore.Icon
          className={SubframeUtils.twClassNames(
            "text-body font-body text-subtext-color",
            {
              "text-warning-700": variant === "reminder",
              hidden: variant === "overdue",
            }
          )}
          name="FeatherCalendar"
        />
        {text ? (
          <span
            className={SubframeUtils.twClassNames(
              "text-label font-label text-subtext-color",
              {
                "text-warning-700": variant === "reminder",
                "text-error-700": variant === "overdue",
              }
            )}
          >
            {text}
          </span>
        ) : null}
      </div>
    );
  }
);

export const TicketStatus = TicketStatusRoot;
